
require('main.scss');
require('offline-plugin/runtime').install();

// Vendor js
var picturefill = require('picturefill');
var lazyload = require('lazysizes');
var bgset = require('lazysizes/plugins/bgset/ls.bgset');
var parentfit = require('lazysizes/plugins/parent-fit/ls.parent-fit');
// var webfont = require('webfont');

// General js
var initMobileMenu = require('menu-mobile');
var initIndex = require('index');

//var initVisualComposer = require('visual-composer');

// Particular js
var initContact = require('contact');
var initSerial = require('serial');
var initUserSerial = require('serial-user');
var initStores = require('stores');
var initRepair = require('repair');
var initFaq = require('faq');

var initCategory = require('category');
var initProduct = require('product');

var initAuth = require('authentication');
var initOrder = require('order-opc');

// User Account
require('history');

//initVisualComposer();

var initCMS = require('cms');

$(document).ready(function(){

	// General js
	initMobileMenu();
	initIndex();

	// Particular js
	initContact();
	initSerial();
	initUserSerial();
	initStores();
	initRepair();
	initFaq();

	initCategory();
	initProduct();

	initAuth();
	initOrder();

	initCMS();

});

require('rgpd/rgpd');

// require('cookieconsent');
// require('cookieconsent/build/cookieconsent.min.css');

// window.addEventListener("load", function(){
// window.cookieconsent.initialise({
//   "palette": {
//     "popup": {
//       "background": "#edeff5",
//       "text": "#838391"
//     },
//     "button": {
//       "background": "#000"
//     }
//   },
//   "showLink": false,
//   "content": {
//   	"header": "Cookies",
//     "message": "En poursuivant votre navigation, vous acceptez l'utilisation de cookies pour vous assurer une utilisation optimale de notre site Internet, vous proposer des services, des offres et des contenus publicitaires adaptés à vos centres d'intérêts ainsi que réaliser des statistiques de visite.",
//     "dismiss": "J'accepte"
//   }
// })});



// WEBPACK FOOTER //
// ./js/common.js